import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import * as Admin from "../store/ducks/admin.duck";
import { Button, Form, Row, Col, Modal } from "react-bootstrap";
import { Grid, FormControl, Select, MenuItem, makeStyles } from '@material-ui/core';
import ReactQuill from 'react-quill';
import { Formik } from 'formik';
import * as Yup from 'yup';
import '../../_metronic/_assets/css/app2.css';
import 'react-quill/dist/quill.snow.css';

export default function BookingLink(props) {
    
  const dispatch = useDispatch()

    const [newNote, setNewNote] = useState(`Hello ${props.firstName},<br><br>
            
            Here is the link for your appointment with ${props.providerName} at ${props.clientBooking}. <br><br>

            ${props.waitingRoomURL}<br><br>
            
            Thank you, <br><br>
            
            Centralised Service` )

  
  const notes = useSelector(state => state.admin.Notes[props.type])

  const BookingLinkSchema = Yup.object().shape({
    noteSelector: Yup.string().required(),

    useExistingContact: Yup.boolean(),

    email: Yup.string().when(
      ['noteSelector', 'useExistingContact'],
      {
        is: (selector, useExisting) => selector === 'Email' && !useExisting,
        then: Yup.string()
          .required('Email is required')
          .email('Invalid email address'),
      }
    ),

    mobilephone: Yup.string().when(
      ['noteSelector', 'useExistingContact'],
      {
        is: (selector, useExisting) => selector === 'SMS' && !useExisting,
        then: Yup.string()
          .required('Mobile phone number is required')
          .matches(/^[0-9+()\s-]+$/, 'Invalid mobile phone number'),
      }
    ),

    subject: Yup.string().when('noteSelector', {
      is: 'Email',
      then: Yup.string().required('Subject is required'),
    }),

    message: Yup.string().required('Message is required'),
  });

 
  const copyBookingLink = async () => {
    //
    try {
      await navigator.clipboard.writeText(props.waitingRoomURL);
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
  };


  function getDefaultMessage(selector, props) {
    if (selector === 'SMS') {
      return `Hello ${props.firstName}, here is the link ${props.waitingRoomURL} for appointment with ${props.providerName} at ${props.clientBooking}. Thank you, Centralised Service`;
    }

    return `Hello ${props.firstName},<br><br>
  here is the link for your appointment with ${props.providerName} at ${props.clientBooking}. <br><br>

  ${props.waitingRoomURL}
  <br><br>

  Thank you,<br><br>
  Centralised Service`;
  }


  const useStyles = makeStyles((theme) => ({
    root: {
      // minWidth: 200,
      // maxWidth: 200,
    },
    media: {
      height: 200,
    },
    title: {
      fontSize: 14,
    },
    pos: {
      marginBottom: 12,
    },
  }));
  
  const classes = useStyles();

  function getActionColour(noteSelector) {
    if (noteSelector === 'Note') {
      return '#ebfae8';
    } else if (noteSelector === 'Email') {
      return '#d2f9fa';
    } else if (noteSelector === 'SMS') {
      return '#faefcf';
    }
    return 'white';
  }

  return (
    <>
      <Formik
        initialValues={{
          noteSelector: 'Email',
          useExistingContact: true,
          email: props.email || '',
          mobilephone: props.mobilephone || '',
          subject: 'Upcoming Booking Link',
          message: newNote,
        }}
        validationSchema={BookingLinkSchema}
        onSubmit={(values) => {
          const formData = new FormData();

          formData.append('type', props.type);
          formData.append('pkid', props.pkid);
          formData.append('selector', values.noteSelector);
          formData.append('subject', values.subject);
          formData.append('note', values.message);
          if (!values.useExistingContact) {
            if (values.noteSelector === 'Email') {
              formData.append('recipient', values.email);
            } else if (values.noteSelector === 'SMS') {
              formData.append('recipient', values.mobilephone);
            }
          }

          dispatch(
            Admin.actions.postNote({
              formData,
              type: props.type,
              pkID: props.pkid,
            })
          );

          props.setShowLink(false);
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleSubmit,
          setFieldValue,
          isValid,
        }) => (
          <Form onSubmit={handleSubmit}>
            <Grid container spacing={4}>
              <Grid item md={12}>
                <Row>
                  <Col md="12">
                    <Form.Group>
                      <FormControl variant="outlined" margin="dense">
                        <Form.Label>Select Action</Form.Label>
                        <Select
                          name="noteSelector"
                          value={values.noteSelector}
                          onChange={(e) => {
                            const selector = e.target.value;

                            setFieldValue('noteSelector', selector);
                            setFieldValue('useExistingContact', true);

                            // Update message via Formik
                            setFieldValue(
                              'message',
                              getDefaultMessage(selector, props)
                            );
                          }}
                          style={{ backgroundColor: getActionColour(values.noteSelector) }}
                        >
                          <MenuItem value="Email">Email</MenuItem>
                          <MenuItem value="SMS">SMS</MenuItem>
                        </Select>
                      </FormControl>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col md="12">
                    <Form.Group>
                      <Form.Label>Recipient</Form.Label>

                      <Form.Check
                        type="radio"
                        label={`Use existing ${
                          values.noteSelector === 'Email' ? 'email' : 'mobile'
                        }`}
                        name="useExistingContact"
                        checked={values.useExistingContact}
                        onChange={() => setFieldValue('useExistingContact', true)}
                      />

                      <Form.Check
                        type="radio"
                        label={`Enter new ${
                          values.noteSelector === 'Email' ? 'email' : 'mobile'
                        }`}
                        name="useExistingContact"
                        checked={!values.useExistingContact}
                        onChange={() => setFieldValue('useExistingContact', false)}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                {values.noteSelector === 'Email' && !values.useExistingContact && (
                  <Row>
                    <Col md="12">
                      <Form.Group>
                        <Form.Label>New Email Address</Form.Label>
                        <Form.Control
                          type="email"
                          name="email"
                          value={values.email}
                          onChange={handleChange}
                          isInvalid={touched.email && !!errors.email}
                          placeholder="Enter email address"
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.email}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>
                )}
                {values.noteSelector === 'SMS' && !values.useExistingContact && (
                  <Row>
                    <Col md="12">
                      <Form.Group>
                        <Form.Label>New Mobile Number</Form.Label>
                        <Form.Control
                          type="text"
                          name="mobilephone"
                          value={values.mobilephone}
                          onChange={handleChange}
                          isInvalid={touched.mobilephone && !!errors.mobilephone}
                          placeholder="Enter mobile number"
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.mobilephone}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>
                )}
                {values.noteSelector === 'Email' && (
                  <Row>
                    <Col md="12">
                      <Form.Group>
                        <Form.Label>Subject</Form.Label>
                        <Form.Control
                          name="subject"
                          value={values.subject}
                          onChange={handleChange}
                          isInvalid={touched.subject && !!errors.subject}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.subject}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>
                )}
                {(values.noteSelector === 'SMS' || values.noteSelector === 'Email') && (
                  <Row>
                    <Col md="12" className="quill-field">
                      <Form.Group>
                        <Form.Label>Message</Form.Label>

                        {values.noteSelector === 'SMS' ? (
                          <Form.Control
                            as="textarea"
                            rows={2}
                            name="message"
                            value={values.message}
                            onChange={handleChange}
                          />
                        ) : (
                          <ReactQuill
                            theme="snow"
                            value={values.message}
                            onChange={(val) => setFieldValue('message', val)}
                          />
                        )}

                        {touched.message && errors.message && (
                          <p className="error-help">{errors.message}</p>
                        )}
                      </Form.Group>
                    </Col>
                  </Row>
                )}
                <Row>
                  <Grid
                    container
                    alignItems="center"
                    justifyContent="space-between"
                    style={{ padding: 10 }}
                  >
                    <Grid item>
                      <Button
                        variant="success"
                        size="sm"
                        type="submit"
                        disabled={!isValid}
                      >
                        Send
                      </Button>
                    </Grid>

                    <Grid item>
                      <Button
                        variant="primary"
                        size="sm"
                        onClick={copyBookingLink}
                      >
                        Copy Booking Link
                      </Button>
                    </Grid>
                  </Grid>
                </Row>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </>
  );
}
  
